import { createGlobalStyle } from 'styled-components'
import styled from 'styled-components'
import { giphyWhite } from '@giphy/js-brand'
import { mobile } from 'shared/util/media-query'

export const MarketingMainHeader = styled.h1`
    font-family: 'NexaBlack', serif;
    font-size: 46px;
    line-height: 54px;
    margin-bottom: 20px;

    ${mobile.css`
        font-size: 32px;
        line-height: 38px;
        margin-bottom: 15px;
    `}
`

export const MarketingParagraph = styled.p`
    font-family: 'interface';
    font-size: 18px;
    font-weight: normal;
    letter-spacing: 0.4px;
    line-height: 26px;
    opacity: 0.8;

    ${mobile.css`
        letter-spacing: 0px;
        font-size: 18px;
    `}
`

export const MarketingLink = styled.a`
    text-decoration: none;
    border-bottom: none;
    font-size: 16px;
    font-weight: bold;
    font-family: 'interface', serif;
`
export const MiniHeader = styled.h3`
    font-family: 'interface', serif;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0px;
    text-transform: none;
`
export const SuperMiniHeader = styled.h6`
    font-family: 'interface', serif;
    font-size: 16px;
    font-weight: bold;
    line-height: 22px;
    margin-bottom: 5px;
    text-align: center;
`

export const GraphSubHeader = styled(SuperMiniHeader)`
    text-align: left;
`

const GiphyMarketingStyles = createGlobalStyle`
    body {
        margin: 0 !important;
        width: 100% !important;
        color: ${giphyWhite} !important;
        background: black;
    }

    body, html {
        text-align: unset !important;
    }

    section {
        margin: 0px;
        padding: 0px;
        border-width: 0px;
    }
`

export default GiphyMarketingStyles
